var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3c-.393 0-.794.138-1.078.422-.284.284-.422.685-.422 1.078v.75h-4.5v1.5H6v12A2.262 2.262 0 0 0 8.25 21h9a2.262 2.262 0 0 0 2.25-2.25v-12h.75v-1.5h-4.5V4.5c0-.393-.138-.794-.422-1.078C15.044 3.138 14.643 3 14.25 3h-3Zm0 1.5h3v.75h-3V4.5ZM7.5 6.75H18v12c0 .416-.334.75-.75.75h-9a.748.748 0 0 1-.75-.75v-12ZM9 9v8.25h1.5V9H9Zm3 0v8.25h1.5V9H12Zm3 0v8.25h1.5V9H15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bea3cc8da3fe5eca5bcf96362ed0268e.svg";
export { ForwardRef as ReactComponent };